import api from "./axios";

class ServiceApplicators {
  async getApplicatorsForSelectBox() {
    const { data } = await api.get("/applicators/combobox/fill");
    return data;
  }

  async findById(id) {
    const { data } = await api.get(`/applicators/${id}`);
    return data;
  }
}

export default new ServiceApplicators();
